export const tableActionsStyles = () => ({
  actionButton: {
    borderRadius: '50%',
    border: '1px solid #333',
    height: '1.9em',
    width: '1.9em',
    margin: '0 4px',
  },
  actionRow: {
    display: 'flex',
    justifyContent: 'space-around',
  },
})
